import { isValidPhoneNumber as _isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

export function isValidPhoneNumber(val: string): boolean {
  return _isValidPhoneNumber(val, 'BE');
}

export function formatPhoneNumber(val: string, pretty: boolean = false): string {
  const parsed = parsePhoneNumberFromString(val, 'BE');
  if (!parsed) return val;
  if (pretty) {
    return parsed.format('INTERNATIONAL');
  } else {
    return parsed.format('E.164');
  }
}
